import User from 'components/setting/models/user';
import React from 'react';

export const TaskBoardContext = React.createContext<{
  taskTypes: any[] | undefined;
  taskOutComes: any[] | undefined;
  users: User[] | undefined;
}>({ taskTypes: [], taskOutComes: [], users: [] });

export default TaskBoardContext;
